// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".\\+u9bly6T9zCslOw9x7PA0A\\=\\={width:24px;height:24px}._1K9WzRGoMPDd1a9rgxEArA\\=\\={height:33.4px}.Ua2bLAewD\\+rpiBWETs6ajA\\=\\={fill:var(--textSecondary,#6e6e6e);fill-rule:evenodd}.Ua2bLAewD\\+rpiBWETs6ajA\\=\\=.HS\\+F09XkDGQojVM0qrLy2A\\=\\={fill:var(--themePrimary,#0078d4)}._2YhKb9bdwKhi4u06EcMcbQ\\=\\={fill:var(--themeLight,#c7e0f4)}.K9J4k8rEg3qcBYdW37xIPg\\=\\={font-weight:500;font-size:14px;fill:var(--textSecondary,#6e6e6e)}.K9J4k8rEg3qcBYdW37xIPg\\=\\=.HS\\+F09XkDGQojVM0qrLy2A\\=\\={fill:var(--themePrimary,#0078d4)}", ""]);
// Exports
exports.locals = {
	"calendarModuleSVG": "+u9bly6T9zCslOw9x7PA0A==",
	"calendarModuleSVGPastFuture": "_1K9WzRGoMPDd1a9rgxEArA==",
	"svgIcon": "Ua2bLAewD+rpiBWETs6ajA==",
	"selected": "HS+F09XkDGQojVM0qrLy2A==",
	"svgIconLight": "_2YhKb9bdwKhi4u06EcMcbQ==",
	"svgText": "K9J4k8rEg3qcBYdW37xIPg=="
};
module.exports = exports;
